import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape } from '@bibliocommons/bc-prop-types';
import { ShelvesOutline } from '@bibliocommons/base-icons';
import { bindAll } from '@bibliocommons/utils-react';
import BibScreenReaderDescription from 'app/components/shared/BibScreenReaderDescription';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import ComboButton from '@bibliocommons/combo-button';
import { IconButton } from '@bibliocommons/base-buttons';
import { SHELF_NAMES, DROPDOWN_ORDER } from 'app/constants/ShelfConstants';
import './AddToShelfButton.scss';

export default class AddToShelfButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClick(shelfName) {
    const { bib, reciprocalRank } = this.props;

    this.props.shelfActions.addToShelf({
      metadataId: bib.get('id'),
      shelfToAdd: shelfName,
      reciprocalRank
    });
  }

  getOptions() {
    const { bib, primaryShelfName } = this.props;
    const briefInfo = bib.get('briefInfo');
    const shelfNames = Immutable.List(DROPDOWN_ORDER).sortBy(shelf => (shelf === primaryShelfName ? 0 : 1));

    return shelfNames.map(shelfName =>
      Immutable.Map({
        value: shelfName,
        label: (
          <span className="shelf-option">
            {shelfName === primaryShelfName && <ShelvesOutline />}
            <span aria-hidden>
              <FormattedMessage id={`label_shelf_${shelfName}`} />
            </span>
            <ScreenReaderMessage>
              <FormattedMessage
                id="ada_add_to_named_shelf"
                values={{
                  title: <BibScreenReaderDescription bibBrief={briefInfo} />,
                  shelf: shelfName
                }}
              />
            </ScreenReaderMessage>
          </span>
        )
      })
    );
  }

  screenReaderMessage = bib => (
    <FormattedMessage
      id="ada_add_to_different_shelf"
      values={{
        title: <BibScreenReaderDescription bibBrief={bib.get('briefInfo')} />
      }}
    />
  );

  render() {
    const { bib, rounded, disabled, shelfTransactions, iconOnly } = this.props;
    const isAdding = shelfTransactions.getIn([bib.get('id'), 'isAdding']);

    return (
      <div className="cp-add-to-shelf-button">
        {iconOnly ? (
          <IconButton
            dataKey="add-to-shelf-button"
            className="icon-only"
            isLoading={isAdding}
            disabled={disabled}
            handleClick={() =>
              this.handleClick(
                this.getOptions()
                  .first()
                  .get('value')
              )}
          >
            <ShelvesOutline />
            <ScreenReaderMessage>{this.screenReaderMessage(bib)}</ScreenReaderMessage>
          </IconButton>
        ) : (
          <ComboButton
            block
            rounded={rounded}
            isLoading={isAdding}
            disabled={disabled}
            handleClick={this.handleClick}
            options={this.getOptions()}
            dataKey="add-to-shelf-button"
            renderDropdownLabel={() => this.screenReaderMessage(bib)}
          />
        )}
      </div>
    );
  }
}

AddToShelfButton.propTypes = {
  bib: bibShape.isRequired,
  primaryShelfName: PropTypes.string,
  shelfTransactions: ImmutablePropTypes.map,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  rounded: PropTypes.bool,
  disabled: PropTypes.bool,
  reciprocalRank: PropTypes.number,
  iconOnly: PropTypes.bool
};

AddToShelfButton.defaultProps = {
  primaryShelfName: SHELF_NAMES.FOR_LATER
};
